<div class="flex justify-center w-full md:mt-11 pb-8">
    <img src="assets/icons/Icons/other-payment-options/masterpass_logo.png" alt="masterpass logo">
</div>
<div class="w-full">
    <p class="my-6">Pay conveniently and securely using Masterpass&#33;</p>
    <p class="my-4">Masterpass is supported by most of South Africa&#39;s leading banks, simply scan the QR code using your supported banking app or any other Scan To Pay app</p>
    <div class="grid grid-cols-4 gap-1 md:grid-cols-6 md:gap-2">
        <b class="col-span-1">Step 1:</b>
        <p class="col-span-3 md:col-span-5">Scan the QR code using your chosen app</p>
    </div>
    <div class="grid grid-cols-4 gap-1 md:grid-cols-6 md:gap-2">
        <b class="col-span-1">Step 2:</b>
        <p class="col-span-3 md:col-span-5">Authorize the payment</p>
    </div>
    <div class="grid grid-cols-4 gap-1 md:grid-cols-6 md:gap-2">
        <b class="col-span-1">Step 3:</b>
        <p class="col-span-3 md:col-span-5">Your Payment will be processed successfully</p>
    </div>
</div>